// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"SimpleImageUpload_imageContainer__uJPZE","imageContainerAspectRatio":"SimpleImageUpload_imageContainerAspectRatio__fgxUF"};